/**
 * 账户安全服务
 * 对接 /api/v1/accounts/*
 */
import { API_BASE_URL } from '../config/api';

class SecurityService {
    getAuthHeaders(token) {
        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        };
    }

    async handleResponse(response, defaultError = '请求失败') {
        let data = {};
        try {
            data = await response.json();
        } catch {
            data = {};
        }

        if (!response.ok) {
            const error = new Error(data?.error || data?.message || defaultError);
            error.response = { status: response.status, data };
            throw error;
        }

        return data;
    }

    async getSecurityStatus(token) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/security/status/`, {
            method: 'GET',
            headers: this.getAuthHeaders(token),
        });
        return this.handleResponse(response, '获取安全状态失败');
    }

    async changePassword(token, data) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/security/change-password/`, {
            method: 'POST',
            headers: this.getAuthHeaders(token),
            body: JSON.stringify(data),
        });
        return this.handleResponse(response, '修改密码失败');
    }

    async sendSmsForChangePhone(token, data) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/security/send-sms/`, {
            method: 'POST',
            headers: this.getAuthHeaders(token),
            body: JSON.stringify(data),
        });
        return this.handleResponse(response, '发送验证码失败');
    }

    async changePhone(token, data) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/security/change-phone/`, {
            method: 'POST',
            headers: this.getAuthHeaders(token),
            body: JSON.stringify(data),
        });
        return this.handleResponse(response, '换绑手机号失败');
    }

    async changeUsername(token, username) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/security/change-username/`, {
            method: 'POST',
            headers: this.getAuthHeaders(token),
            body: JSON.stringify({ username }),
        });
        return this.handleResponse(response, '修改用户名失败');
    }

    async createWechatBindSession(token) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/wechat/bind-session/`, {
            method: 'POST',
            headers: this.getAuthHeaders(token),
        });
        return this.handleResponse(response, '创建绑定会话失败');
    }

    async checkWechatBindStatus(token, ticket) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/wechat/bind-status/?ticket=${ticket}`, {
            method: 'GET',
            headers: this.getAuthHeaders(token),
        });
        return this.handleResponse(response, '检查微信绑定状态失败');
    }

    async unbindWechat(token) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/wechat/unbind/`, {
            method: 'POST',
            headers: this.getAuthHeaders(token),
        });
        return this.handleResponse(response, '解绑微信失败');
    }

    async mockBindWechat(token, ticket) {
        const response = await fetch(`${API_BASE_URL}/api/v1/accounts/wechat/mock-bind/`, {
            method: 'POST',
            headers: this.getAuthHeaders(token),
            body: JSON.stringify({ ticket }),
        });
        return this.handleResponse(response, '模拟微信绑定失败');
    }
}

const securityService = new SecurityService();
export default securityService;
